import React, { FunctionComponent } from "react";

export const DottedLineSvgComponent: FunctionComponent = () => (
    <svg width="220px" height="30px" viewBox="0 0 500 50" xmlns="http://www.w3.org/2000/svg">
        <line x1="0" y1="25" x2="440" y2="25" stroke="black" strokeWidth="10" strokeDasharray="10, 10" />
    </svg>
);
